import { useState } from "react";
import { IMAGES } from "../data/site";

export const SmartImage = ({ src, alt, className = "" }) => {
  const [url, setUrl] = useState(src);
  return (
    <img
      src={url}
      alt={alt}
      loading="lazy"
      onError={() => url !== IMAGES.fallback && setUrl(IMAGES.fallback)}
      className={className}
    />
  );
};
